export const backgroundSizeMap = {
    "contain": "contain",
    "cover": "cover",
    "default": "default"
}